import axios from 'axios';
import getHeaderToken from './getHeaderToken';
import { Logger } from 'aws-amplify';

const logger = new Logger('updateEmployeeLimitSettings-log');

const updateEmployeeLimitSettings = async (officeNo, employeeCount, countRetirementFlag, countLeaveFlag) => {
  const url = process.env.REACT_APP_EMPLOYEE_LIMIT_API
  const body = {
    office_number: officeNo,
    employee_limit: Number(employeeCount),
    count_retirement_flag: countRetirementFlag,
    count_leave_flag: countLeaveFlag,
  };

  try {
    const header = await getHeaderToken();
    const response = await axios.put(url, body, header);
    if (response.status === 200 || response.status === 204) {
      logger.info('職員設定が正常に更新されました。');
      // 必要に応じて追加の処理（例: データの再フェッチなど）
    } else {
      logger.error('職員設定の更新に失敗しました。ステータスコード:', response.status);
      alert('職員設定の更新に失敗しました。');
    }
  } catch (error) {
    logger.error('API呼び出し中にエラーが発生しました:', error);
    alert('職員設定の更新中にエラーが発生しました。');
  }
};

export default updateEmployeeLimitSettings;
